import { render, staticRenderFns } from "./publications.vue?vue&type=template&id=3e4c35d5&"
import script from "./publications.vue?vue&type=script&lang=js&"
export * from "./publications.vue?vue&type=script&lang=js&"
import style0 from "./publications.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports